import uri from 'urijs';
import Wix from '../services/wix-sdk-polyfill';
import { getConfig } from '../services/config';

const MODAL_POSITION = {
  origin: Wix.WindowOrigin.FIXED,
  placement: Wix.WindowPlacement.CENTER,
};

export const openWixModal = (type, props = {}) => {
  return (dispatch, getState, { baseUrl }) => {
    const onClose = data => {
      const action = data && data.message;
      if (action) {
        dispatch(action);
      }
    };
    const data = JSON.stringify({ type, props });
    const debug = uri(window.location.search).search(true).debug;
    const url = `${baseUrl}/modal`;

    Wix.openPopup(
      `${url}?data=${data}&section-url=${getConfig().sectionUrl}&debug=${debug}`,
      '100%',
      '100%',
      MODAL_POSITION,
      onClose,
      Wix.Theme.BARE
    );
  };
};



// WEBPACK FOOTER //
// ./app/actions/open-wix-modal.js